/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!*********************************!*\
  !*** ./src/js/swiper-mobile.js ***!
  \*********************************/
// // https://github.com/nolimits4web/swiper/issues/1072
// $(document).ready(function () {
//   if (typeof define === 'function' && define.amd) {
//     define([], function () {
//       // console.log(typeof Swiper)
//       'use strict';
//       return Swiper;
//     });
//   }
//   var swiper = new Swiper(".mySwiper", {
//     direction: "vertical",
//     pagination: {
//       el: ".swiper-pagination",
//       clickable: true,
//     },
//   });
//   $('.RoundButton').click(function () {
//     if ($(this).attr('data-action') == 'open-product-zoom') {
//       swiper.zoom.in();
//       //$(this).hide();
//     }
//   });
// });
// $('body').bind('touchmove', function (e) {
//   if ($(".swiper-slide-active").attr('data-image-position') == $(".swiper-slide:last-child").attr('data-image-position')) {
//     swiper.allowTouchMove = false;
//     setTimeout(() => {
//       swiper.allowTouchMove = true;
//       swiper.allowSlideNext = true;
//     }, 3000);
//   }
// });
/******/ })()
;